import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import mn from "./locales/mn.json";
import en from "./locales/en.json";

const savedLang = localStorage.getItem("astring-lang") ?? "mn";

i18n.use(initReactI18next).init({
  resources: { mn: { translation: mn }, en: { translation: en } },
  lng: savedLang,
  fallbackLng: "mn",
  interpolation: { escapeValue: false },
});

/*
  Keep <html lang> in step with the active locale.

  index.html shipped a hardcoded lang="en" that nothing ever updated, so a screen
  reader read the whole Mongolian page — the DEFAULT one — with English phonetics
  (WCAG 3.1.1). The boot script in index.html sets the attribute before first
  paint; this keeps it correct after the toggle flips.

  It lives here rather than in lang-toggle.tsx deliberately: `changeLanguage` has
  more than one caller, and a sync that only fires from one button is a sync that
  is already wrong somewhere else.
*/
const syncDocumentLang = (lng: string) => {
  document.documentElement.lang = lng.split("-")[0];
};

syncDocumentLang(i18n.language ?? "mn");
i18n.on("languageChanged", syncDocumentLang);

export default i18n;
